/**
 * @generated SignedSource<<353c1ddef05bfa0aad15836bf93998be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteSavedReportInput = {
  id: string;
  reportService?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteSavedReportMutation$variables = {
  input: DeleteSavedReportInput;
};
export type deleteSavedReportMutation$data = {
  readonly deleteSavedReport: {
    readonly deletedSavedReportId: string | null;
  } | null;
};
export type deleteSavedReportMutation = {
  variables: deleteSavedReportMutation$variables;
  response: deleteSavedReportMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSavedReportPayload",
    "kind": "LinkedField",
    "name": "deleteSavedReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSavedReportId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteSavedReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteSavedReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c28f7c89edd9c6fbc03b0c035244304c",
    "id": null,
    "metadata": {},
    "name": "deleteSavedReportMutation",
    "operationKind": "mutation",
    "text": "mutation deleteSavedReportMutation(\n  $input: DeleteSavedReportInput!\n) {\n  deleteSavedReport(input: $input) {\n    deletedSavedReportId\n  }\n}\n"
  }
};
})();

(node as any).hash = "54d79ae77d476868532b21124ff07801";

export default node;
